import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShowAll = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 10 10",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.001 6.563q.739 0 1.254-.517.516-.517.516-1.255 0-.739-.517-1.254A1.7 1.7 0 0 0 5 3.02q-.738 0-1.254.517a1.7 1.7 0 0 0-.516 1.255q0 .738.517 1.254t1.255.516m-.003-.605q-.487 0-.826-.34a1.13 1.13 0 0 1-.339-.829q0-.487.341-.825.342-.339.829-.339t.825.341.339.828q0 .487-.341.826a1.13 1.13 0 0 1-.828.338M5 7.917a4.67 4.67 0 0 1-2.75-.865 5.27 5.27 0 0 1-1.833-2.26 5.27 5.27 0 0 1 1.833-2.26A4.67 4.67 0 0 1 5 1.666q1.52 0 2.75.864 1.23.865 1.833 2.26A5.27 5.27 0 0 1 7.75 7.053 4.67 4.67 0 0 1 5 7.917" })
});
export default SvgShowAll;
